import React from 'react';
import { ListItem, ListItemText, Box, List, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import SettingsPanelSection from '../SettingsPanelSection';
import { connect } from 'react-redux';
import { createActions } from '../../store';
import { secondsToDigitalText } from '../../../../../utilities/timeUtilities';
import DurationTextFieldListItem from '../../../../list-items/DurationTextFieldListItem';
import SettingsPanelAudioButton from '../SettingsPanelAudioButton';
import { DEFAULT_AUDIO_TRACK } from '../../CreatePageConstants';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import TooltipHelpButton from '../../../../buttons/TooltipHelpButton';

const styles = theme => ({
    emptyText: {
        padding: theme.spacing(2)
    }
});

class SettingsPanelSectionAudio extends React.Component {
    render() {
        const { classes, audioEndTime, audioDuration, audioStartTime, audioUrl, save, bassMaxMagnitude, wideMaxMagnitude, audioAnalyzing, analyzeAudioMaxMagnitudes } = this.props;
        const selectedDuration = audioEndTime - audioStartTime;
        const isDefaultAudio = audioUrl && audioUrl == DEFAULT_AUDIO_TRACK.SOUND_URL;

        return (
            <SettingsPanelSection
                title='Audio'
                action={<SettingsPanelAudioButton save={save} />}
            >
                {(audioUrl && !isDefaultAudio) ?
                    <List dense disablePadding>
                        <ListItem>
                            <ListItemText>
                                Total Duration
                            </ListItemText>
                            <Box>
                                <Typography variant='body2'>
                                    {secondsToDigitalText(audioDuration)}
                                </Typography>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <ListItemText>
                                Selected Duration
                            </ListItemText>
                            <Box>
                                <Typography variant='body2'>
                                    {secondsToDigitalText(selectedDuration)}
                                </Typography>
                            </Box>
                        </ListItem>
                        <DurationTextFieldListItem
                            text='Start Time'
                            onChange={this.onStartTimeChange}
                            value={audioStartTime}
                            ariaLabel='Start time'
                            toolTip='The audio timestamp where the video will start.'
                        />
                        <DurationTextFieldListItem
                            text='End Time'
                            onChange={this.onEndTimeChange}
                            value={audioEndTime}
                            ariaLabel='End time'
                            toolTip='The audio timestamp where the video will end.'
                        />
                        {((!bassMaxMagnitude || !wideMaxMagnitude) && !audioAnalyzing) &&
                            <ListItem>
                                <ListItemText>
                                    Analyze
                                    <TooltipHelpButton title='Analyze your audio to view a synchronized preview of your audio in the editor.' />
                                </ListItemText>
                                <Box>
                                    <CircleProgressButton
                                        variant='outlined'
                                        size='small'
                                        onClick={() => analyzeAudioMaxMagnitudes(audioUrl)}
                                    >
                                        Start Analysis
                                    </CircleProgressButton>
                                </Box>
                            </ListItem>
                        }
                    </List>
                    :
                    <Typography
                        variant='body2'
                        align='center'
                        className={classes.emptyText}
                    >
                        Upload an MP3, WAV, or AAC file to sync your audio with the preview.
                    </Typography>
                }
            </SettingsPanelSection>
        );
    }

    onStartTimeChange = (value) => {
        const { updateAudioSettings, audioEndTime } = this.props;

        if (value < audioEndTime)
            updateAudioSettings({ startTime: value });
    }

    onEndTimeChange = (value) => {
        const { updateAudioSettings, audioStartTime, audioDuration } = this.props;

        if (value > audioStartTime && value <= audioDuration) {
            updateAudioSettings({ endTime: value });
        }
    }
}

const mapStateToProps = (state) => {
    const {
        audioDuration,
        audioAnalyzing,
    } = state.create;

    const {
        startTime: audioStartTime,
        endTime: audioEndTime,
        url: audioUrl,
        bassMaxMagnitude,
        wideMaxMagnitude
    } = state.create.audioSettings;

    return {
        audioDuration,
        audioAnalyzing,
        audioStartTime,
        audioEndTime,
        audioUrl,
        bassMaxMagnitude,
        wideMaxMagnitude
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateAudioSettings = (newSettings) => dispatch(createActions.updateAudioSettings(newSettings));
    const analyzeAudioMaxMagnitudes = (audioFile) => dispatch(createActions.analyzeAudioMaxMagnitudes(audioFile));

    return {
        updateAudioSettings,
        analyzeAudioMaxMagnitudes
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SettingsPanelSectionAudio, styles));